// extracted by mini-css-extract-plugin
module.exports = {"propertyCall":"style_propertyCall__7Dv69","callInner":"style_callInner__bzykX","callButton":"style_callButton__9wSa_","hidePropertyCall":"style_hidePropertyCall__brw3O"};